'use client';
import defaultImage from '@/assets/icons/img.png';
import JumpLink from '@/components/JumpLink';
import { getExposureRecord } from '../../tempo_track';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import Image from 'next/image';
import './index.scss';
type TImg = {
  name: string;
  image: string;
  jump?:
    | {
        jumpDev: any;
        jumpId: number;
        jumpType: string; // 跳转类型
        jumpValue:
          | any
          | {
              // 跳转值
              link: string;
            };
      }
    | any;
};
/** <单图组件> 可配置入参约束
 * @param radius 圆角
 * @param top 上边距
 * @param bottom 下边距
 * @param leftRight 左右边距
 * @param imageList: 导航列表
 */
interface ImageProps {
  moduleData: any;
  pageCode: string;
  floorIndex: number;
}
export default function Module({ moduleData, pageCode, floorIndex }: ImageProps) {
  let load = false; // 数据获取状态
  let dataSource: any = null; // 储存一份response源数据
  // let defaultImage = require("./img/img.png")
  let pageConfig: any = {
    radius: '0px',
    top: '12px',
    bottom: '12px',
    leftRight: '0px',
    height: '100%',
    image: {
      name: '',
      jump: '',
      image: '',
    },
  };

  let styleInfo = {};
  const refreshStyle = () => {
    styleInfo = {
      borderRadius: pageConfig.radius ? pageConfig.radius + 'px' : 0,
      marginTop: pageConfig.top ? pageConfig.top + 'px' : 0,
      marginLeft: pageConfig.leftRight ? pageConfig.leftRight + 'px' : 0,
      marginRight: pageConfig.leftRight ? pageConfig.leftRight + 'px' : 0,
      marginBottom: pageConfig.bottom ? pageConfig.bottom + 'px' : 0,
      height: pageConfig.height ? pageConfig.height + 'px' : '100%',
    };
  };
  /** 初始化数据 */
  const initConfig = () => {
    dataSource = moduleData;
    const { dataStyle, dataBatch } = dataSource;
    load = true;
    try {
      pageConfig = {
        radius: dataStyle.radiusMargin.radius,
        top: dataStyle.radiusMargin.top,
        bottom: dataStyle.radiusMargin.bottom,
        leftRight: dataStyle.radiusMargin.leftRight,
        height: dataBatch?.imageList[0].height,
        image: {
          name: dataBatch?.imageList[0].name,
          jump: dataBatch?.imageList[0].jump || '',
          imageUrl: dataBatch?.imageList[0].image.imageUrl || '',
        },
        image_h5: {
          imageUrl: dataBatch?.imageList[0]?.image_h5?.imageUrl || '',
        },
      };
      refreshStyle();
    } catch (e) {
      console.log('h5-singlegraph-catch', e);
    }
  };

  initConfig();
  //埋点params
  const exposureRecord = getExposureRecord(pageCode);
  const trackingParams = {
    moduleInstanceId: moduleData?.id,
    page_id: pageCode,
    pos: floorIndex,
    img: pageConfig.image.imageUrl,
  };

  //判断使用哪张图
  const isInApp = () => {
    if (uaParse().isInJoybuyApp) {
      return pageConfig.image;
    } else {
      if (pageConfig.image_h5.imageUrl) {
        return pageConfig.image_h5;
      } else {
        return pageConfig.image;
      }
    }
  };
  const finalImage = isInApp();

  return (
    <div className='uk-h5-image-box'>
      {pageConfig?.image?.imageUrl ? (
        <JumpLink jumpParams={pageConfig?.image?.jump}>
          <div
            className='h5-singlegraph'
            style={{ ...styleInfo }}
            exptag={'exp|' + exposureRecord.cms_TempoPage_image_expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}'
            data-exptag-json-param={JSON.stringify(trackingParams)}
          >
            {!pageConfig.image || !pageConfig.image.imageUrl ? (
              <div className='default-img'>
                <Image className='_img' src={defaultImage} alt='' />
              </div>
            ) : (
              <img className='singleraph' src={finalImage.imageUrl} />
            )}
          </div>
        </JumpLink>
      ) : (
        <></>
      )}
    </div>
  );
}
